module.exports = __webpack_public_path__ + "img/jiangsu.dbd4e965.jpg";